import React from 'react'

class GoogleMap extends React.Component {
  styles = {
    map: {
      ...this.props.style,
      border: 0,
    },
  };

  render() {
    return (
      <iframe
        src={this.props.url}
        width={this.props.width || '100%'}
        height={this.props.height || 480}
        className={this.styles.map}
        frameBorder={0}
        allowFullScreen
      />
    );
  }
}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/google-map.js